if (!customElements.get('cart-icon-bubble')) {
  class CartIconBubble extends HTMLElement {
    constructor() {
      super();

      this.toggleButton = this.querySelector('[aria-controls="cart-drawer"]');
      this.cartDrawer = document.querySelector('cart-drawer');
      this.behavior = this.dataset.atc;

      if (this.cartDrawer && this.toggleButton) {
        // Check if both this.cartDrawer and this.toggleButton are truthy
        this.toggleButton.addEventListener('click', this.toggle.bind(this));
      }
    }

    toggle(event) {
      event.preventDefault();
      event.stopPropagation();

      if (this.behavior === 'go_to_cart_page') {
        window.location.href = window.routes.cart_url;
      } else {
        this.cartDrawer.drawer.classList.contains(this.cartDrawer.activeClass)
          ? this.cartDrawer.close()
          : this.cartDrawer.open();
      }
    }
  }
  window.CartIconBubble = CartIconBubble;
  customElements.define('cart-icon-bubble', CartIconBubble);
}
